import { render, staticRenderFns } from "./AssignmentSearch.vue?vue&type=template&id=3cf9e800&scoped=true&"
import script from "./AssignmentSearch.vue?vue&type=script&lang=js&"
export * from "./AssignmentSearch.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentSearch.vue?vue&type=style&index=0&id=3cf9e800&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf9e800",
  null
  
)

export default component.exports